const JoinWithUs = ()=>{
    let c;
    return (
        <h1>Join With Us Page</h1>
    )
}

export default JoinWithUs